<template>
  <div
    class="content"
    v-wechat-title="
      $store.state.region.re_name + '-节庆-图片直播-' + routeDetail.title + ''
    "
  >
    <new-top :title="$route.params.title"></new-top>
    <div class="center">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="200"
      >
        <div class="title">
          <img :src="routeDetail.url" alt="" />
          <span>{{ routeDetail.title }}</span>
        </div>
        <div class="pics">
          <span>图片直播：</span>
          <!-- 瀑布流列表 -->
          <waterfall-flow-list
            :pictureList="list"
            @toDetail="toDetail"
          />
        </div>
      </van-list>
    </div>
    <fanhui-top />
  </div>
</template>
<script>
import newTop from "@/components/travel/newTop.vue";
import waterfallFlowList from "@/components/travel/waterfallFlowList";
import { holshootsphoto } from "@/api/travel";
import { ImagePreview } from 'vant';
import fanhuiTop from "@/components/fanhuiTop";
export default {
  data() {
    return {
      page: 1,
      list: [],
      routeDetail: {},
      loading: false,
      finished: false,
      arr: []
    };
  },
  components: {
    newTop,
    waterfallFlowList,
    fanhuiTop
  },
  methods: {
    isLoding() {
      holshootsphoto({
        holid: this.$route.params.holId,
        page: this.page,
      }).then((res) => {
        if (res.shootsphotos.data.length > 0) {
          res.shootsphotos.data.forEach((v) => {
            this.list.push({
                id: v.id,
                albumphotos: v.shoots_img
            });
            this.arr.push(v.shoots_img)
          });
        }
        this.loading = false;
        if (
          res.shootsphotos.data.length <= 4 ||
          res.shootsphotos.data.length == 0
        ) {
          this.finished = true;
        }
      });
    },
    toDetail(e,index){
        ImagePreview({
            images: this.arr,
            startPosition: index,
        });
    },
    onLoad() {
      this.isLoding();
      this.page++;
    },
  },
  created() {
    this.routeDetail = this.$route.params;
  },
};
</script>
<style scoped>
.content {
  min-height: 100vh;
  background: #fff;
}
.center {
  padding-top: 44px;
}
.title {
}
.title span {
  display: flex;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 6px;
}
.title img {
  width: 100%;
}
.pics {
  
}
.pics span {
  display: block;
  margin: 0 6px;
  margin-bottom: 10px;
}
</style>